// extracted by mini-css-extract-plugin
module.exports = {"AdminFiles":"adminFiles_AdminFiles__3VQSO","pictPreview":"adminFiles_pictPreview__3WtjL"};